import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { MatCalendar, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { PaymentService } from './payments.service';
import { GetAccessoriesComponent } from './getAccessories/get-accessories.component';
import Swal from 'sweetalert2';
import { RequestComponent } from './request/request.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { AppFilesService } from 'src/app/services/app-files.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-plati-online',
    templateUrl: './plati-online.component.html',
    styleUrls: ['./plati-online.component.scss'],
})
export class PlatiOnlineComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    helper = helper;
    editorConfig!: AngularEditorConfig;
    isLoading = false;
    isFilterLoading = false;
    showCard: boolean = false;
    isActive: boolean = true;

    // Popover dates
    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date();
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'last_0_days';

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);

        if (numberOfDays == 1) {
            this.selectedStartDate = this.selectedEndDate = date
        } else {
            this.selectedStartDate = date;
            this.selectedEndDate = new Date();
        }

        this.updateCalendarView(this.startCalendar, date);
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    setAllYears(): void {
        this.selectedStartDate = new Date(2018, 7, 1); // 1 August
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedFilteringButton = 'all_years';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date
    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    toggleCard() {
        this.showCard = !this.showCard;
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    tranzactiiDateForm: FormGroup = new FormGroup({
        dateFrom: new FormControl(new Date()),
        dateEnd: new FormControl(new Date()),
    })

    totalDMU: number = 0;
    totalDGITL: number = 0;
    total: number = 0;
    searchParamsForm!: FormGroup;

    //Form Initial Values
    initialFormValues = {
        cnp_cui: '',
        cet_name: '',
        interogare_id: '',
        payment_status: '-1',
        detailsIncluded: '-1',
        dgitl_rol_id: '',
        id_payment: '',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            cnp_cui: new FormControl(''),
            cet_name: new FormControl(''),
            interogare_id: new FormControl(''),
            payment_status: new FormControl('-1'),
            detailsIncluded: new FormControl('-1'),
            dgitl_rol_id: new FormControl(''),
            id_payment: new FormControl(''),
        });
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT();
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.payments.nomenclatoare.informatiiPlati.payments;

    dataTablesParameters: any = {
        data: {
            key: 'parameter',
        },
        source: '',
    };

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private paymentsService: PaymentService,
        private appFilesService: AppFilesService,
        private fb: FormBuilder,
        private breakpointObserver: BreakpointObserver,
        private permissionsService: PermissionsService,
    ) {
        this.tomorrow.setDate(this.today.getDate() + 1);
    }

    ngOnInit(): void {
        this.renderDT();
        // this.editorConfig = initializeEditor();
        this.buildSearchParamsForm();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            responsive: true,
            searching: false,
            pageLength: 25,
            order: [[0, 'desc']],

            ajax: (dataTablesParameters: any, callback: any) => {
                dataTablesParameters.dp_event_status = this.isActive ? 1 : 0; // Allows date filtering
                dataTablesParameters.date_from_event = this.formatDate(this.selectedStartDate);;
                dataTablesParameters.date_to_event = this.formatDate(this.selectedEndDate);

                dataTablesParameters.cnp_cui = this.searchParamsForm.value.cnp_cui;
                dataTablesParameters.cet_name = this.searchParamsForm.value.cet_name;
                dataTablesParameters.interogare_id = this.searchParamsForm.value.interogare_id;
                dataTablesParameters.dgitl_rol_id = this.searchParamsForm.value.dgitl_rol_id;
                dataTablesParameters.id_payment = this.searchParamsForm.value.id_payment;
                dataTablesParameters.payment_status = this.searchParamsForm.value.payment_status;
                dataTablesParameters.source = this.searchParamsForm.value.detailsIncluded;

                // dataTablesParameters.totalDGITL = 0;
                // dataTablesParameters.totalDMU = 0;
                // if (this.searchParamsForm.value.detailsIncluded === 1) {
                //   dataTablesParameters.totalDGITL = 1;
                // } else if (this.searchParamsForm.value.detailsIncluded === 2) {
                //   dataTablesParameters.totalDMU = 2;
                // }

                this.isLoading = true;

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        this.totalDMU = resp.data.totalDMU;
                        this.totalDGITL = resp.data.totalDGITL;
                        this.total = resp.data.total;

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: null,
                    render: (data: any) => {
                        return `
                            <div>P: #${data.id_payment}</div>
                            <div>I: #${data.interogare_id}</div>
                        `;
                    },
                },
                {
                    title: 'Cetățean',
                    data: 'name',
                },
                {
                    title: 'CNP/CUI',
                    data: 'cnp',
                    orderable: false,
                },
                {
                    title: 'Total',
                    data: null,
                    orderable: false,
                    render: (data: any) => {
                        return `
                            <div>${data.amount} RON</div>
                        `;
                    },
                },
                {
                    title: 'Dată plată',
                    data: 'created_at',
                    orderable: false,
                },
                {
                    title: 'DGITL Rol ID',
                    data: null,
                    render: (data: any) => {
                        return `
                            <div>${data.dgitl_rol_id}</div>
                        `;
                    },
                },
                {
                    title: 'Transaction ID ',
                    data: null,
                    render: (data: any) => {
                        return `
                            ${data.transaction_ids}
                        `;
                    },
                },
                {
                    title: 'Accesorii',
                    data: 'accesorii',
                    orderable: false,
                },
                {
                    title: '#',
                    data: 'info',
                    orderable: false,
                    className: 'all',
                    render: (data: any, type: any, row: any, met: any) => {
                        return `
                            <button type="button" class="btn btn-xs btn-warning mt-1 ` + (row.info.includes('viewAccesorii') ? 'detalii' : 'd-none') + `">Detalii</button>
                            <button type="button" class="btn btn-xs btn-info mt-1 ` + (row.info.includes('viewReq') ? 'req' : 'd-none') + `">REQ</button>
                            <button type="button" class="btn btn-xs btn-success mt-1 ` + (row.info.includes('viewRes') ? 'res' : 'd-none') + `">RES</button>
                            <button type="button" class="btn btn-xs btn-danger mt-1 ` + (row.info.includes('deletePaymentDuplicate') ? 'delete' : 'd-none') + `">Remove Payment</button>
                            <button type="button" class="btn btn-xs btn-default mt-1 ` + (row.info.includes('approvePayment') ? 'approve' : 'd-none') + `">Approve Payment</button>
                        `
                    }
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const detaliiBtn = lastTd?.querySelector('.detalii') as HTMLElement;
                const reqBtn = lastTd?.querySelector('.req') as HTMLElement;
                const resBtn = lastTd?.querySelector('.res') as HTMLElement;
                const deleteBtn = lastTd?.querySelector('.delete') as HTMLElement;
                const approveBtn = lastTd?.querySelector('.approve') as HTMLElement;

                if (detaliiBtn) {
                    if (!this.permissionsService.hasPermission('payments-module.plati-online.detalii')) {
                        detaliiBtn.style.display = 'none';
                    }

                    detaliiBtn.addEventListener('click', () => {
                        this.viewAccesorii(data.interogare_id)
                    })
                }

                if (reqBtn) {
                    if (!this.permissionsService.hasPermission('payments-module.plati-online.req')) {
                        reqBtn.style.display = 'none';
                    }

                    reqBtn.addEventListener('click', () => {
                        this.viewReq(data.interogare_id)
                    })
                }

                if (resBtn) {
                    if (!this.permissionsService.hasPermission('payments-module.plati-online.res')) {
                        resBtn.style.display = 'none';
                    }

                    resBtn.addEventListener('click', () => {
                        this.viewRes(data.id_payment)
                    })
                }

                if (deleteBtn) {
                    if (!this.permissionsService.hasPermission('payments-module.plati-online.delete')) {
                        deleteBtn.style.display = 'none';
                    }

                    deleteBtn.addEventListener('click', () => {
                        this.deletePaymentDuplicate(data.id_payment)
                    })
                }

                if (approveBtn) {
                    if (!this.permissionsService.hasPermission('payments-module.plati-online.approve')) {
                        approveBtn.style.display = 'none';
                    }

                    approveBtn.addEventListener('click', () => {
                        this.approvePayment(data.id_payment)
                    })
                }

                return row;
            },
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });

        this.closePopover();
    }

    openDialogAccessories(data: any): void {
        const dialogRef = this.dialog.open(GetAccessoriesComponent, {
            minWidth: 950,
            minHeight: 200,
            data,
        });
    }

    openDialogRequest(data: any): void {
        let configData = {
            data: data,
            width: '60%',
            height: 'auto',
            minWidth: '275px',
        };

        const dialogRef = this.dialog.open(RequestComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 599px)', // xs breakpoint
            '(min-width: 600px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 599px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', 'auto')
                } else {
                    // Larger devices
                    dialogRef.updateSize('40%', 'auto')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Cerere adăugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    viewAccesorii(id: number): void {
        this.isLoading = true;
        this.paymentsService.getAccessories(id).subscribe(
            (data) => {
                this.isLoading = false;
                this.openDialogAccessories(data);
            },
            (error) => {
                console.error('Detalii Button', error);
            }
        );
    }

    viewRes(interogare_id: any): void {
        this.isLoading = true;
        this.paymentsService.viewPayments(interogare_id).subscribe(
            (data: any) => {
                this.isLoading = false;
                this.openDialogRequest(data.data);
            },
            (error: any) => {
                console.error('Response Button', error);
            }
        );
    }

    viewReq(interogare_id: any): void {
        this.isLoading = true;
        this.paymentsService.requestPayments(interogare_id).subscribe(
            (data: any) => {
                this.isLoading = false;
                this.openDialogRequest(data.data);
            },
            (error: any) => {
                console.error('Response Button', error);
            }
        );
    }

    resetInvoiceStatus(id: number) {
        Swal.fire({
            title: this.helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să resetați statusul facturii!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;

                this.paymentsService.resetInvoiceStatus(id).subscribe(
                    (data: any) => {
                        this.isLoading = false;
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.success,
                            text: 'Statusul a fost resetat cu succes.',
                            icon: 'success',
                            confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                        }).then(() => {
                            this.rerenderDT();
                        });
                    },
                    (error: any) => {
                        console.error('Response Button', error);
                    }
                );
            }
        })
    }

    deletePaymentDuplicate(id: number) {
        Swal.fire({
            title: this.helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să ștergeți plata din sistem!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;

                this.paymentsService.deletePaymentDuplicate(id).subscribe(
                    (data: any) => {
                        this.isLoading = false;
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.success,
                            text: 'Plată ștearsă cu succes.',
                            icon: 'success',
                            confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                        }).then(() => {
                            this.rerenderDT();
                        });
                    },
                    (error: any) => {
                        console.error('Response Button', error);
                    }
                );
            }
        })
    }

    approvePayment(id: number) {
        Swal.fire({
            title: this.helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să confirmați plata virtual în sistem. Confirmați doar dacă plata a fost operată în integrisoft!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;

                this.paymentsService.approvePayment(id).subscribe(
                    (data: any) => {
                        this.isLoading = false;
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.success,
                            text: 'Plată confirmată cu succes.',
                            icon: 'success',
                            confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                        }).then(() => {
                            this.rerenderDT();
                        });
                    },
                    (error: any) => {
                        console.error('Response Button', error);
                    }
                );
            }
        })
    }

    downloadCSV(source: number) {
        let fullPath = this.paymentsService.downloadPaymentsCsvUrl;
        let formValues = { ...this.tranzactiiDateForm.value };
        let formValuesForm: FormGroup = this.fb.group(formValues);

        let dateFrom = new Date(formValuesForm.get('dateFrom')?.value);
        let dateEnd = new Date(formValuesForm.get('dateEnd')?.value);

        formValuesForm.get('dateFrom')?.setValue(dateFrom.toISOString().split('T')[0]);
        formValuesForm.get('dateEnd')?.setValue(dateEnd.toISOString().split('T')[0]);

        this.appFilesService.downloadCsvFile(fullPath, source, formValuesForm.value);
    }

    toggleIsActive() {
        this.isActive = !this.isActive;
    }
}
